import { render, staticRenderFns } from "./popup-do-doc.vue?vue&type=template&id=cb4682c8&scoped=true"
import script from "./popup-do-doc.vue?vue&type=script&lang=js"
export * from "./popup-do-doc.vue?vue&type=script&lang=js"
import style0 from "./popup-do-doc.vue?vue&type=style&index=0&id=cb4682c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4682c8",
  null
  
)

export default component.exports